import React from "react";
import "./style.less";

function View({ className = "", positive, back, hover = true, showBack, width = "200px", height = "200px", style = {} }) {

  const status = showBack ? "back" : "positive";

  return (
      <div className={`cr-hoverFlip${!hover ? "--" + status : ""} ${hover ? "hover" : ""} ${className}`}>
        <div className="cr-hoverFlip__content" style={{width, height, ...style}}>
          <div className={`cr-hoverFlip__content__positive`}>{positive}</div>
          <div className={`cr-hoverFlip__content__back`}>{back}</div>
        </div>
      </div>
  )
}

export default View
